export enum USER_ACTION_TYPES {
  'login_begins' = 'user_login',
  'login_success' = 'user_login_success',
  'login_error' = 'user_login_error',
  'logout_begins' = 'logout_begins',
  'logout_success' = 'logout_success',
  'logout_error' = 'logout_error',
  'signup_begins' = 'user_signup',
  'signup_success' = 'user_signup_success',
  'signup_error' = 'user_signup_error',
  'signup_without_pass_begins' = 'signup_without_pass',
  'signup_without_pass_success' = 'signup_without_pass_success',
  'signup_without_pass_error' = 'signup_without_pass_error',
  'save_user_begins' = 'save_user_begin',
  'save_user_success' = 'save_user_success',
  'save_user_error' = 'save_user_error',
  'update_user_begin' = 'update_user_begin',
  'update_user_success' = 'update_user_success',
  'update_user_error' = 'update_user_error',
  'update_image' = 'update_image',
  'delete_child_begins' = 'delete_child_begins',
  'delete_child_success' = 'delete_child_success',
  'delete_child_error' = 'delete_child_error',
  'payment_completion_begins' = 'payment_completion_begins',
  'payment_completion_success' = 'payment_completion_success',
  'update_parental_instructions_complete' = 'update_parental_instructions_complete',
  'send_verification_email' = 'send_verification_email',
  'need_verify_user_in_mixpanel' = 'need_verify_user_in_mixpanel',
  'set_is_phone_number' = 'set_is_phone_number'
}



// WEBPACK FOOTER //
// ./src/store/user/types.ts